<template>
  <div class="col-xs-12">
    <b-table
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
    >
      <template v-slot:head(company)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(store)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(storeZip)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(soldArticles)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(returnedAmount)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(returnedArticles)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(soldAmount)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(turnoverAfterReturns)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(avgShippingTime)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(avgReturnTime)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(shippedArticles)="data">
        <span>{{ data.column | translate }}</span>
      </template>
      <template v-slot:head(turnoverFromShipped)="data">
        <span>{{ data.column | translate }}</span>
      </template>
    </b-table>
  </div>
</template>
<script>
  export default {
    name: 'resTable',
    props: ['items'],
    data () {
      return {
        sortBy: 'soldAmount',
        sortDesc: true,
        fields: [
          {key: 'company', sortable: true},
          {key: 'store', sortable: true},
          {key: 'storeZip', sortable: true},
          {key: 'soldArticles', sortable: true},
          {key: 'returnedAmount', sortable: true},
          {key: 'returnedArticles', sortable: true},
          {key: 'soldAmount', sortable: true},
          {key: 'turnoverAfterReturns', sortable: true},
          {key: 'avgShippingTime', sortable: true},
          {key: 'avgReturnTime', sortable: true},
          {key: 'shippedArticles', sortable: true},
          {key: 'turnoverFromShipped', sortable: true},
        ]
      }
    }
  }
</script>
